import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
  Box,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import useAdd from "../../api/useAdd";
import useFetchObjects from "../../api/useFetchObjects";
import { useTranslation } from "react-i18next";

const ExpenseCategoryAdd = ({ open, onClose, token }) => {
  const { t } = useTranslation();
  const { handleAdd, loading, resetForm } = useAdd(
    "shop/expense-categories",
    token
  );

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [shop, setShop] = useState("");

  const { data: shopsData } = useFetchObjects(
    ["shops"],
    "shop/shop",
    token
  );
  const shops = shopsData?.results || shopsData || [];

  const handleSubmit = () => {
    const formData = new FormData();
    formData.append("name", name);
    formData.append("description", description);
    formData.append("shop", shop);
    handleAdd(formData);
  };

  useEffect(() => {
    if (resetForm) {
      setName("");
      setDescription("");
      setShop("");
      onClose();
    }
  }, [resetForm, onClose]);

  useEffect(() => {
    if (shops.length === 1) {
      setShop(shops[0].id);
    }
  }, [shops]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{t("expenseCategory.addExpenseCategory")}</DialogTitle>
      <DialogContent>
        <Box component="form" noValidate sx={{ mt: 1 }}>
          <TextField
            margin="dense"
            label={t("expenseCategory.name")}
            fullWidth
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <TextField
            margin="dense"
            label={t("expenseCategory.description")}
            fullWidth
            multiline
            rows={3}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
          <FormControl fullWidth margin="dense" required>
            <InputLabel>{t("expenseCategory.shop", "Shop")}</InputLabel>
            <Select
              value={shop}
              label={t("expenseCategory.shop", "Shop")}
              onChange={(e) => setShop(e.target.value)}
            >
              {shops.map((s) => (
                <MenuItem key={s.id} value={s.id}>
                  {s.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          {t("expenseCategory.cancel")}
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={loading || !name || !shop}
        >
          {loading ? (
            <CircularProgress size={24} />
          ) : (
            t("expenseCategory.save")
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExpenseCategoryAdd;
